import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  HttpClient
} from '@angular/common/http';

import {
  ActivatedRoute,
  Router
} from '@angular/router';

import { AdminNavbar }
from '../admin-navbar/admin-navbar';

@Component({
  selector:
    'app-categories-edit',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    AdminNavbar
  ],

  templateUrl:
    './categories-edit.html',

  styleUrls: [
    './categories-edit.scss'
  ]
})
export class CategoriesEdit implements OnInit {

  category = {
    id: 0,
    name: '',
    slug: '',
    image: ''
  };

  imagePreview = '';

  loading = false;

  uploading = false;

  saving = false;

  errorMessage = '';

  id = 0;

  cloudinaryUrl =
    'https://api.cloudinary.com/v1_1/dle6ao4m7/image/upload';

  constructor(
    private route:
      ActivatedRoute,

    private http:
      HttpClient,

    private router:
      Router,

    private cdr:
      ChangeDetectorRef
  ) {}

  ngOnInit(): void {

    this.id = Number(
      this.route.snapshot.paramMap.get('id')
    );

    console.log(
      'EDIT CATEGORY ID:',
      this.id
    );

    if (!this.id) {

      this.errorMessage =
        'Invalid category ID.';

      this.cdr.detectChanges();

      return;
    }

    this.loadCategory();
  }

  loadCategory(): void {

    this.loading = true;

    this.errorMessage = '';

    const url =
      `https://lazzaro-api1.onrender.com/api/categories/${this.id}`;

    console.log(
      'GET:',
      url
    );

    this.http.get<any>(url)

      .subscribe({

        next: (response: any) => {

          console.log(
            'GET RESPONSE:',
            response
          );

          this.category = {
            id: response.id ?? 0,

            name:
              response.name ?? '',

            slug:
              response.slug ?? '',

            image:
              response.image ?? ''
          };

          // Postojeća slika
          this.imagePreview =
            this.category.image;

          this.loading = false;

          this.cdr.detectChanges();
        },

        error: (err) => {

          console.error(
            'GET CATEGORY ERROR:',
            err
          );

          console.error(
            'STATUS:',
            err.status
          );

          console.error(
            'ERROR BODY:',
            err.error
          );

          this.errorMessage =
            `Error loading category (${err.status}).`;

          this.loading = false;

          this.cdr.detectChanges();
        }
      });
  }

  onNameChange(): void {

    this.category.slug =
      this.category.name

        .toLowerCase()

        .replace(/\s+/g, '-')

        .replace(/č/g, 'c')
        .replace(/ć/g, 'c')
        .replace(/š/g, 's')
        .replace(/ž/g, 'z')
        .replace(/đ/g, 'dj');

    this.cdr.detectChanges();
  }

  onFileSelected(event: any): void {

    const file =
      event.target.files[0];

    if (!file)
      return;

    this.uploading = true;

    this.errorMessage = '';

    const formData =
      new FormData();

    formData.append(
      'file',
      file
    );

    formData.append(
      'upload_preset',
      'lazzaro_unsigned'
    );

    console.log(
      'Uploading image...'
    );

    this.http.post(
      this.cloudinaryUrl,
      formData
    )

    .subscribe({

      next: (response: any) => {

        console.log(
          'CLOUDINARY RESPONSE:',
          response
        );

        this.category.image =
          response.secure_url;

        this.imagePreview =
          response.secure_url;

        this.uploading = false;

        this.cdr.detectChanges();
      },

      error: (err) => {

        console.error(
          'CLOUDINARY ERROR:',
          err
        );

        this.errorMessage =
          'Image upload failed.';

        this.uploading = false;

        this.cdr.detectChanges();
      }
    });
  }

  save(): void {

    if (this.uploading)
      return;

    if (!this.category.name.trim()) {

      this.errorMessage =
        'Name is required.';

      this.cdr.detectChanges();

      return;
    }

    if (!this.category.slug.trim()) {

      this.errorMessage =
        'Slug is required.';

      this.cdr.detectChanges();

      return;
    }

    this.saving = true;

    this.errorMessage = '';

    const data = {

      name:
        this.category.name.trim(),

      slug:
        this.category.slug.trim(),

      image:
        this.category.image
    };

    const url =
      `https://lazzaro-api1.onrender.com/api/categories/${this.id}`;

    console.log(
      'PUT:',
      url
    );

    console.log(
      'PUT DATA:',
      data
    );

    this.http.put(
      url,
      data
    )

    .subscribe({

      next: (response) => {

        console.log(
          'PUT RESPONSE:',
          response
        );

        this.saving = false;

        this.cdr.detectChanges();

        alert(
          'Category updated successfully'
        );

        this.router.navigate([
          '/admin/categories'
        ]);
      },

      error: (err) => {

        console.error(
          'PUT CATEGORY ERROR:',
          err
        );

        console.error(
          'STATUS:',
          err.status
        );

        console.error(
          'ERROR BODY:',
          err.error
        );

        this.errorMessage =
          `Update failed (${err.status}).`;

        this.saving = false;

        this.cdr.detectChanges();
      }
    });
  }
}